import { useTranslation } from 'react-i18next'

import { useMsal } from '@azure/msal-react'
import { Button } from 'primereact/button'

const LogoutButton: React.FC = () => {
  const { t } = useTranslation()
  const { instance } = useMsal()

  const handleLogout = (): void => {
    instance.logoutRedirect({
      account: instance.getActiveAccount(),
      postLogoutRedirectUri: '/',
    })
    window.localStorage.clear()
  }

  return (
    <Button
      className="button p-button"
      label={t('common.auth.signOut')}
      icon="pi pi-sign-out"
      onClick={handleLogout}
    />
  )
}

export default LogoutButton
